import { useState } from 'react';
import { Icon } from '../../../../../../icon/Icon';
import { Button } from '../../../../../../button/Button';
import { Integration } from '../../../../../../shared/interfaces/integration';
import { ObjectConfig } from '../../../../interfaces/object';
import { FieldsConfig } from '../../../FieldsConfig/FieldsConfig';

export function InferSchemaSuccess({
  objectId,
  objectName,
  pipeline
}: {
  objectId: string;
  objectName: string;
  pipeline: Integration;
}) {
  const [fieldsModalOpen, setFieldsModalOpen] = useState(false);

  return (
    <>
      <div className='center-flex-row'>
        <Icon dataId='success' name='circle-tick' className='text-success text-bold' />

        <span className='ml-1 text-medium text-success'>Schema inferred successfully</span>
      </div>

      <Button
        dataId='validate-inferred-schema'
        className='mt-3'
        onClick={() => setFieldsModalOpen(true)}
      >
        Validate Object Schema
      </Button>

      <FieldsConfig
        open={fieldsModalOpen}
        setOpen={isOpen => {
          setFieldsModalOpen(isOpen);
        }}
        onApplyChanges={() => {}}
        integration={pipeline}
        object={{ id: objectId, k0: objectName } as unknown as ObjectConfig}
        isViewMode={false}
      />
    </>
  );
}
